import { AttachmentParams } from './types';

export const validateFile = (file: File) => {
  const fileSize = file.size;

  if (fileSize > 5000000)
    return new Error('Individual attachment file size is greater than 5MB');

  return undefined;
};

export const validateFiles = (files: File[]) => {
  let totalFileSize = 0;
  let invalidFileError;

  files.every((file) => {
    totalFileSize += file.size;
    invalidFileError = validateFile(file);

    if (invalidFileError) return false;

    return true;
  });

  if (invalidFileError) return invalidFileError;

  if (totalFileSize > 9000000)
    return new Error('Total attachments file size is greater than 9MB');

  return undefined;
};

export const validateAttachments = (attachments: AttachmentParams[]) => {
  const invalidAttachment = attachments.find((attachment) => !attachment.file);

  if (invalidAttachment)
    return new Error(
      'Attachment is missing one or more of the required properties: file',
    );

  const files = attachments.map((attachment) => attachment.file);
  const invalidFilesError = validateFiles(files);

  if (invalidFilesError) return invalidFilesError;

  return undefined;
};
